export const APLICATION_ROLES = {
  Owner: 'ADM',
  MMMAdm: '3MADM',
  Installer: 'INSTALLER',
  Distributor: 'DISTRIBUTOR',
  Admin: '3M',
  SegvelInst: 'SEGVELINST',
  Segvel: 'SEGVEL',
};
